import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import constClass from '../../Constants/Constants';
import Loading from '../Loading/Loading';

const AppLottery = ({ siteId, mallId, customerId, disabled, liffAccessToken, ticketClick }) => {
  const [lockData, setLockData] = useState(true);
  const [lotteryResultFlag, setLotteryResultFlag] = useState(false);
  const [lotteryProcessCompletedFlag, setLotteryProcessCompletedFlag] = useState(false);
  const [customerAppLottery, setCustomerAppLottery] = useState([]);
  const [appLotteryBonus, setAppLotteryBonus] = useState([]);

  const refreshData = useCallback(async () => {
    try {
      const customerAppLotteryPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customerapplottery/line/search`, { site_id: siteId, mall_id: mallId, customer_id: customerId, line_id: liffAccessToken });
      const customerAppLottery = (await customerAppLotteryPromise).data;
      const appLotteryBonusPromise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/applotterybonus/line/${siteId}/${mallId}`);
      const applotterybonus = (await appLotteryBonusPromise).data;
      if (customerAppLottery) {
        customerAppLottery.lottery === constClass.FLAG.ON ? setLotteryResultFlag(true) : setLotteryResultFlag(false);
      }
      setCustomerAppLottery(customerAppLottery);
      setAppLotteryBonus(applotterybonus);
    } catch (err) {
      console.log(err);
    } finally {
      setLockData(false);
    }
  }, [siteId, mallId, customerId, liffAccessToken]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  const handleStart = async () => {
    setLockData(true);
    try {
      const data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customerapplottery/line/lottery/`, { site_id: siteId, mall_id: mallId, line_id: liffAccessToken })).data;
      if (data.data && data.data.point && data.data.point.lottery && data.data.ticket && data.data.ticket.lottery) {
        setLotteryResultFlag(true);
      }
      else if (data.data && data.data.point && data.data.point.lottery) {
        setLotteryResultFlag(true);
      }
      else if (data.data && data.data.ticket && data.data.ticket.lottery) {
        setLotteryResultFlag(true);
      }
      else {
        setLotteryResultFlag(false);
      }
      const customerAppLotteryPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customerapplottery/line/search`, { site_id: siteId, mall_id: mallId, customer_id: customerId, line_id: liffAccessToken });
      const customerAppLottery = (await customerAppLotteryPromise).data;
      const appLotteryBonusPromise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/applotterybonus/line/${siteId}/${mallId}`);
      const applotterybonus = (await appLotteryBonusPromise).data;
      setCustomerAppLottery(customerAppLottery);
      setAppLotteryBonus(applotterybonus);
      setLotteryProcessCompletedFlag(true);
    } catch (err) {
      console.log(err);
    } finally {
      setLockData(false);
    }
  };

  return (
    lockData ? <Loading /> : (
      <div className="applottery-container">
        <div className="frame50">
          {lotteryProcessCompletedFlag && lotteryResultFlag ? (
            appLotteryBonus.app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).bonus_type === constClass.BONUS_TYPE.BOTH ?
              <img src={`/${siteId}/getpointticket.svg`} alt='getpointticket' className='w-100' />
              : appLotteryBonus.app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).bonus_type === constClass.BONUS_TYPE.POINT ?
                <img src={`/${siteId}/getpoint.svg`} alt='getpoint' className='w-100' />
                : appLotteryBonus.app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).bonus_type === constClass.BONUS_TYPE.TICKET ?
                  <img src={`/${siteId}/getticket.svg`} alt='getticket' className='w-100' />
                  : null
          ) : lotteryProcessCompletedFlag && !lotteryResultFlag ?
            <img src={`/${siteId}/losing.svg`} alt='losing' className='w-100' />
            : <img src={`/${siteId}/gachapon.svg`} alt='gachapon' className='w-100' />
          }

          {lotteryProcessCompletedFlag && lotteryResultFlag && appLotteryBonus.app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).bonus_type === constClass.BONUS_TYPE.BOTH &&
            <div className="applotterypointcouponframe49">
              <div className="frame11">
                <div className="points-held">
                  獲得ポイント
                </div>
                <div className="lottery-frame9">
                  <div className="lottery-points">
                    {appLotteryBonus.app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).point}
                  </div>
                </div>
                <div className="applottery-text3">
                  おめでとうございます！<br />
                  抽選の結果、ポイントとクーポンを<br />
                  ゲットしました。
                </div>
                <button
                  disabled={disabled}
                  onClick={() => ticketClick()}
                   className="button mt-3 text-black bg-white">
                  クーポンを表示する
                </button>
              </div>
            </div>
          }
          {lotteryProcessCompletedFlag && lotteryResultFlag && appLotteryBonus.app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).bonus_type === constClass.BONUS_TYPE.POINT &&
            <div className="applotterypointframe49">
              <div className="frame11">
                <div className="points-held">
                  獲得ポイント
                </div>
                <div className="lottery-frame9">
                  <div className="lottery-points">
                    {appLotteryBonus.app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).point}
                  </div>
                </div>
                <div className="applottery-text3">
                  おめでとうございます！<br />
                  抽選の結果、ポイントをゲットしました。
                </div>
              </div>
            </div>
          }
          {lotteryProcessCompletedFlag && lotteryResultFlag && appLotteryBonus.app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).bonus_type === constClass.BONUS_TYPE.TICKET &&
            <div className="applotterypointframe49">
              <div className="frame11">
                <div className="applottery-text3 my-2">
                  おめでとうございます！<br />
                  抽選の結果、クーポンをゲットしました。
                </div>
                <button
                  disabled={disabled}
                  onClick={() => ticketClick()}
                  className="button mt-3 text-black bg-white">
                  クーポンを表示する
                </button>
              </div>
            </div>
          }
          {lotteryProcessCompletedFlag && !lotteryResultFlag &&
            <div className="applotterypointframe49">
              <div className="frame11">
                <div className="applottery-text3 mt-4">
                  残念でした・・・<br />
                  今回はポイントをゲットできませんでした。<br />
                  次回もぜひご参加ください！
                </div>
              </div>
            </div>
          }
          {!lotteryProcessCompletedFlag &&
            <div className="applotterypointframe49">
              <div className="frame55">
                <div className="frame11">
                  <div className="applottery-text1">
                    {appLotteryBonus && appLotteryBonus.lottery_title ? appLotteryBonus.lottery_title :  <>西鉄ショッピングポイントがあたる<br />
                    抽選にチャレンジしよう！</>}
                  </div>
                  <div className="applottery-text2 mt-1">
                    {appLotteryBonus && appLotteryBonus.lottery_detail ? appLotteryBonus.lottery_detail : <>クーポン画面で特典をご確認ください。<br /></>}                  
                  </div>
                  {customerAppLottery.lottery &&
                    <div className="text-danger mt-1 text-center align-self-center">
                      本日は抽選済みです。
                    </div>
                  }
                  <button
                    disabled={customerAppLottery.lottery || disabled || lockData}
                    onClick={handleStart}
                    className={`button mt-1 text-white ${customerAppLottery.lottery || disabled || lockData ? 'disabled' : 'bg-darkblue'}`}>
                    抽選にチャレンジする
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    )
  );
}

// {!lockData ?
//   <React.Fragment>
//     {lotteryProcessCompletedFlag && lotteryResultFlag ? (
//       <h4 className="text-black">おめでとうございます！抽選に当選しました！</h4>
//     ) : (
//       <h4 className="text-black">毎日くじを引いて、賞品をゲットしよう！</h4>
//     )}
//     <div className="frame54 d-flex flex-column justify-content-center">
//       <div className="bg-white p-4 d-flex flex-column justify-content-center">
//         <div className="align-self-center">
//           {((lotteryProcessCompletedFlag && lotteryResultFlag) || (customerAppLottery.lottery && lotteryResultFlag)) &&
//             <React.Fragment>
//               <h1 className="text-black text-center">あたり</h1>
//                <h1 className="text-black">
//               {customerAppLottery.bonus_id ? 
//                 appLotteryBonus.app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).bonus_type === constClass.BONUS_TYPE.BOTH ?
//                  ticketNameList.find(x => x.ticket_id === appLotteryBonus.app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).ticket_id).ticket_name +
//                  appLotteryBonus.m_app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).point + "ポイント" :
//                   appLotteryBonus.m_app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).bonus_type === constClass.BONUS_TYPE.POINT ?
//                   appLotteryBonus.m_app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).point + "ポイント" :
//                   ticketNameList.find(x => x.ticket_id === appLotteryBonus.m_app_lottery_bonuses.find(x => x.bonus_id === customerAppLottery.bonus_id).ticket_id).ticket_name



//                :lotteryResultData.point && lotteryResultData.ticket ?  + lotteryResultData.point.point + "ポイント" : lotteryResultData.point ? lotteryResultData.point.point + "ポイント" : ticketNameList.find(x => x.ticket_id === lotteryResultData.ticket_id).ticket_name
//               }
//               </h1>

//             </React.Fragment>
//           }
//           {((lotteryProcessCompletedFlag && !lotteryResultFlag) || (customerAppLottery.lottery && !lotteryResultFlag)) &&
//             <h1 className="text-black">はずれ</h1>
//           }
//         </div>
//         {!lotteryProcessCompletedFlag && !customerAppLottery.lottery &&
//           <div className="text-center">
//             <button
//               disabled={disabled}
//               className="button text-white bg-danger buckbutton"
//               onClick={handleStart}
//             >
//               スタート
//             </button>
//           </div>
//         }
//       </div>
//       <div className="text-left ">
//         <h4 className="text-black">毎日くじ&nbsp;概要</h4>
//         <div>
//           <div className="text-black">
//             {appLotteryBonus.m_app_lottery_bonuses && appLotteryBonus.m_app_lottery_bonuses.length > 0 && appLotteryBonus.m_app_lottery_bonuses.map((bonus, index) => (
//               <React.Fragment key={index}>
//                 <h4 className="text-black">{index + 1}等：{bonus.ticket_id ? ticketNameList.find(x => x.ticket_id === bonus.ticket_id).ticket_name + 'チケット' : ''} {bonus.point ? bonus.point + 'ポイント' : ''}</h4><br />
//               </React.Fragment>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   </React.Fragment>
//   : <Loading />}

export default AppLottery;